// 登录页表单验证


// 定义校验方式          必填   值      是否放行
function validatAccount(rules, value, callback) {
  if (value.length > 20) {
    callback(new Error("输入字段不能大于20"));
  } else {
    callback();
  }
}


export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      rules: {
        account: [
          // 必填             提示信息              触发方式
          { required: true, message: "请输入账号", trigger: "blur" },   //element-UI上的方式
          // 校验方式     上面定义的方式         触发方式：内容改变
          { validator: validatAccount, trigger: "change" }       //自定义校验
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      }
    }
  }
}